import configs from '../../config';

const initialState = {
    citiesItems: [],
    direction: configs.mainConfigs.defaultFlightType,
    cabin: configs.mainConfigs.defaultCabin,
    routesCount: 1,
    focusCalendat: {
        date_from: false,
        date_to: false,
    },
    passengers: {
        adt: 1,
        chd: 0,
        inf: 0,
    },
    passengersCount: 1,
    isMaximumPassengers: false,
    isMaximumInf: false,
};

export default initialState;
